import { create } from "zustand";

import type { CommissionDebtError } from "@/lib/validation/commission.schemas";

export type CommissionGateModal = {
  messageFa?: string;
  outstandingDebt?: number;
};

interface CommissionGateState {
  modal: CommissionGateModal | null;
  openFromError: (error: CommissionDebtError) => void;
  closeModal: () => void;
}

export const useCommissionGateStore = create<CommissionGateState>()((set) => ({
  modal: null,

  openFromError: (error) =>
    set({
      modal: {
        messageFa: error.message_fa,
        outstandingDebt: error.outstanding_debt,
      },
    }),

  closeModal: () => set({ modal: null }),
}));
